<template>
  <fragment>
    <iframe
      :src="
        `${this.quoteUrlNew}/app/overview/${
          $route.params.filter ? $route.params.filter : ''
        }?token=${api_token}&lang=${$i18n.locale}-${
          $i18n.locale === 'fr'
            ? $i18n.locale.toUpperCase()
            : $i18n.locale === 'en'
            ? 'GB'
            : 'SE'
        }`
      "
      width="100%"
      height="100%"
      style="min-height:100vh;"
      overflow="scroll"
      frameBorder="0"
    />

    <b-modal
      id="payment-confirm-success"
      :title="$t('pages.payment_confirmation.title_success')"
      ok-only
      :ok-title="$t('pages.payment_confirmation.actionbtn_label')"
    >
      <div class="d-block text-center">
        <b-icon icon="check-circle" scale="6" variant="success" class="m-5" />
        <p>{{ $t('pages.payment_confirmation.body_success') }}</p>
      </div>
    </b-modal>

    <b-modal
      id="payment-confirm-failed"
      :title="$t('pages.payment_confirmation.title_failed')"
      ok-only
      :ok-title="$t('buttons.close')"
    >
      <div class="d-block text-center">
        <p>{{ $t('pages.payment_confirmation.body_failed') }}</p>
      </div>
    </b-modal>
  </fragment>
</template>
<script>
import store from '../store/store';

export default {
  mounted() {
    if (this.$route.params.payment_confirm) {
      if (this.$route.params.payment_confirm === 'success') {
        this.$bvModal.show('payment-confirm-success');
        this.$store.dispatch('getUser');
      } else {
        this.$bvModal.show('payment-confirm-failed');
      }
    }
  },
  data() {
    return {
      quoteUrlNew: process.env.VUE_APP_QUOTES_URL_NEW,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    api_token() {
      return sessionStorage.getItem('api_token');
    },
  },
  metaInfo() {
    return {
      title: this.$t('pages.my_projects.title'),
    };
  },
};
</script>
